import ApiClient from './ApiClient';
import Tenant from '../models/entities/Tenant';

export default class TenantService extends ApiClient {
	async getAll() {
		return this.get<Tenant[]>('Tenants');
	}
}